import { Component, OnDestroy } from '@angular/core';
import {
  NbMediaBreakpoint,
  NbMediaBreakpointsService,
  NbMenuItem,
  NbMenuService,
  NbSidebarService,
  NbThemeService,
} from '@nebular/theme';

import { StateService } from '../../../@core/utils/state.service';

import { Subscription } from 'rxjs/Subscription';
import 'rxjs/add/operator/withLatestFrom';
import 'rxjs/add/operator/delay';

// TODO: move layouts into the framework
@Component({
  selector: 'ngx-sample-layout',
  styleUrls: ['./sample.layout.scss'],
  template: `
    <nb-layout [center]="layout.id === 'center-column'" windowMode>
      <nb-layout-header fixed>
        <ngx-header [position]="sidebar.id === 'start' ? 'normal': 'inverse'"></ngx-header>
      </nb-layout-header>

      <!--<nb-sidebar class="menu-sidebar"-->
                  <!--tag="menu-sidebar"-->
                  <!--responsive-->
                  <!--[end]="sidebar.id === 'end'">-->
        <!--<nb-sidebar-header *ngIf="currentTheme !== 'corporate'">-->
          <!--<a href="#" class="btn btn-hero-success main-btn">-->
            <!--<i class="ion ion-social-github"></i> <span>Support Us</span>-->
          <!--</a>-->
        <!--</nb-sidebar-header>-->
        <!--<ng-content select="nb-menu"></ng-content>-->
      <!--</nb-sidebar>-->

      <nb-sidebar class="menu-sidebar"
                  tag="menu-sidebar"
                  responsive
                  [right]="sidebar.id === 'right'">
        <nb-sidebar-header>
          <img src="/assets/images/DFRC.png" class="ion-crop main-btn"
               *ngIf="showDate === true"
          >
          <div
            *ngIf="showDate === true"
            class="alert alert-hint main-btn"
            role="alert"
            [class.right]="position === 'normal'"
            [class.left]="position === 'inverse'"
          >
            {{date | date: 'yy.MM.dd hh:mm'}}
          </div>
        </nb-sidebar-header>
        <ng-content select="nb-menu"></ng-content>
      </nb-sidebar>

      <nb-layout-column class="main-content">
        <ng-content select="router-outlet"></ng-content>
      </nb-layout-column>

      <nb-layout-column start class="small" *ngIf="layout.id === 'two-column' || layout.id === 'three-column'">
        <nb-menu [items]="subMenu"></nb-menu>
      </nb-layout-column>

      <nb-layout-column class="small" *ngIf="layout.id === 'three-column'">
        <nb-menu [items]="subMenu"></nb-menu>
      </nb-layout-column>

      <nb-layout-footer fixed>
        <ngx-footer></ngx-footer>
      </nb-layout-footer>

      <nb-sidebar class="settings-sidebar"
                  tag="settings-sidebar"
                  state="collapsed"
                  fixed
                  [end]="sidebar.id !== 'end'">
        <ngx-theme-settings></ngx-theme-settings>
      </nb-sidebar>
    </nb-layout>
    <!--<nb-layout [center]="layout.id === 'center-column'" windowMode>-->
      <!--<nb-layout-header fixed>-->
        <!--<ngx-header [position]="sidebar.id === 'left' ? 'normal': 'inverse'"></ngx-header>-->
      <!--</nb-layout-header>-->

      <!--<nb-sidebar class="menu-sidebar"-->
                  <!--tag="menu-sidebar"-->
                  <!--responsive-->
                  <!--[right]="sidebar.id === 'right'">-->
        <!--<nb-sidebar-header>-->
          <!--<img src="/assets/images/DFRC.png" class="ion-crop main-btn"-->
               <!--*ngIf="showDate === true"-->
          <!--&gt;-->
          <!--<div-->
            <!--*ngIf="showDate === true"-->
            <!--class="alert alert-hint main-btn"-->
            <!--role="alert"-->
            <!--[class.right]="position === 'normal'"-->
            <!--[class.left]="position === 'inverse'"-->
          <!--&gt;-->
            <!--{{date | date: 'yy.MM.dd hh:mm'}}-->
          <!--</div>-->
        <!--</nb-sidebar-header>-->
        <!--<ng-content select="nb-menu"></ng-content>-->
      <!--</nb-sidebar>-->

      <!--<nb-layout-column class="main-content">-->
        <!--<ng-content select="router-outlet"></ng-content>-->
      <!--</nb-layout-column>-->

      <!--&lt;!&ndash;<nb-layout-column left class="small" *ngIf="layout.id === 'two-column' || layout.id === 'three-column'">&ndash;&gt;-->
      <!--&lt;!&ndash;<nb-menu [items]="subMenu"></nb-menu>&ndash;&gt;-->
      <!--&lt;!&ndash;</nb-layout-column>&ndash;&gt;-->

      <!--&lt;!&ndash;<nb-layout-column right class="small" *ngIf="layout.id === 'three-column'">&ndash;&gt;-->
      <!--&lt;!&ndash;<nb-menu [items]="subMenu"></nb-menu>&ndash;&gt;-->
      <!--&lt;!&ndash;</nb-layout-column>&ndash;&gt;-->

      <!--<nb-layout-footer fixed>-->
        <!--<ngx-footer></ngx-footer>-->
      <!--</nb-layout-footer>-->

      <!--&lt;!&ndash;<nb-sidebar class="settings-sidebar"&ndash;&gt;-->
      <!--&lt;!&ndash;tag="settings-sidebar"&ndash;&gt;-->
      <!--&lt;!&ndash;state="collapsed"&ndash;&gt;-->
      <!--&lt;!&ndash;fixed&ndash;&gt;-->
      <!--&lt;!&ndash;[right]="sidebar.id !== 'right'">&ndash;&gt;-->
      <!--&lt;!&ndash;<ngx-theme-settings></ngx-theme-settings>&ndash;&gt;-->
      <!--&lt;!&ndash;</nb-sidebar>&ndash;&gt;-->
    <!--</nb-layout>-->
  `,
})
export class SampleLayoutComponent  implements OnDestroy {

  subMenu: NbMenuItem[] = [
    {
      title: 'PAGE LEVEL MENU',
      group: true,
    },
    {
      title: 'Buttons',
      icon: 'ion ion-android-radio-button-off',
      link: '/pages/ui-features/buttons',
    },
    {
      title: 'Grid',
      icon: 'ion ion-android-radio-button-off',
      link: '/pages/ui-features/grid',
    },
    {
      title: 'Icons',
      icon: 'ion ion-android-radio-button-off',
      link: '/pages/ui-features/icons',
    },
    {
      title: 'Modals',
      icon: 'ion ion-android-radio-button-off',
      link: '/pages/ui-features/modals',
    },
    {
      title: 'Typography',
      icon: 'ion ion-android-radio-button-off',
      link: '/pages/ui-features/typography',
    },
    {
      title: 'Animated Searches',
      icon: 'ion ion-android-radio-button-off',
      link: '/pages/ui-features/search-fields',
    },
    {
      title: 'Tabs',
      icon: 'ion ion-android-radio-button-off',
      link: '/pages/ui-features/tabs',
    },
  ];
  layout: any = {};
  sidebar: any = {};

  protected layoutState$: Subscription;
  protected sidebarState$: Subscription;
  protected menuClick$: Subscription;

  showDate: Boolean = true;

  date: Date = new Date();

  constructor(protected stateService: StateService,
              protected menuService: NbMenuService,
              protected themeService: NbThemeService,
              protected bpService: NbMediaBreakpointsService,
              protected sidebarService: NbSidebarService) {
    this.layoutState$ = this.stateService.onLayoutState()
      .subscribe((layout: string) => this.layout = layout);

    this.sidebarState$ = this.stateService.onSidebarState()
      .subscribe((sidebar: string) => {
        this.sidebar = sidebar;
        // console.log('onSidebarState');
        // console.log(sidebar);
      });

    // this.sidebarService.toggle(true);
    this.sidebarService.toggle(false, 'menu-sidebar');

    this.sidebarService.onToggle()
      .subscribe((state: any) => {
        this.showDate = !this.showDate;
        console.log(state);
      });

    // this.sidebarService.onExpand()
    //   .subscribe((state: any) => {
    //     // this.showDate = !this.showDate;
    //     console.log('on Expand');
    //     console.log(state);
    //   });
    //
    // this.sidebarService.onCollapse()
    //   .subscribe((state: any) => {
    //     // this.showDate = !this.showDate;
    //     console.log('on collapse');
    //     console.log(state);
    //   });

    const isBp = this.bpService.getByName('is');
    this.menuClick$ = this.menuService.onItemSelect()
      .withLatestFrom(this.themeService.onMediaQueryChange())
      .delay(20)
      .subscribe(([item, [bpFrom, bpTo]]: [any, [NbMediaBreakpoint, NbMediaBreakpoint]]) => {

        if (bpTo.width <= isBp.width) {
          this.sidebarService.collapse('menu-sidebar');
        }
      });
  }

  expand(tag?: string) {
    console.log('tag');
    console.log(tag);
  }

  ngOnDestroy() {
    this.layoutState$.unsubscribe();
    this.sidebarState$.unsubscribe();
    this.menuClick$.unsubscribe();
  }
}
